import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faBox, faChevronRight, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';
import { DayBookService } from '../../share/services/day-book/day-book.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from '../../share/services/common-service/common-service.service';
import { Router } from '@angular/router';
import { LedgersService } from '../../share/services/ledgers/ledgers.service';

@Component({
  selector: 'app-stock-movement',
  templateUrl: './stock-movement.component.html',
  styleUrls: ['./stock-movement.component.scss'],
  standalone: false
})
export class StockMovementComponent implements OnChanges {
  protected readonly faBox = faBox;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faArrowRight = faArrowRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  stockHighlights = {
    openingStock: { value: 0, label: 'Opening Stock' },
    closingStock: { value: 0, label: 'Closing Stock' },
    stockIn: { value: 0, label: 'Stock In', },
    stockOut: { value: 0, label: 'Stock Out', subtitle: 'via Sales' },
    netChange: { value: 0, label: 'Net Change', subtitle: 'end of day' }
  };
  stockmovementList: any[] = [];
  listCount: number = 0;
  loader: boolean = false;
  errMsg: string = '';
  scroolLoader: boolean = false;
  page: number = 0;
  endOfResults: boolean = false;

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
    private readonly router: Router,
    private readonly ledgersService: LedgersService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.refreshData()
    }
  }

  refreshData() {
    this.loader = true;
    this.stockHighlights.openingStock.value = 0;
    this.stockHighlights.closingStock.value = 0;
    this.stockHighlights.stockIn.value = 0;
    this.stockHighlights.stockOut.value = 0;
    this.stockHighlights.netChange.value = 0;
    this.stockmovementList = [];
    this.page = 0;
    this.endOfResults = false;
    this.getData();
  }


  getData() {
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate,
      page: this.page
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    forkJoin({
      list: this.dayBookService.getStockmovementList(params),
      sale: this.dayBookService.getStockMovementStats(params)
    }).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.scroolLoader = false;
        this.mapSaleResponse(res.sale.data || {});
        this.listCount = this.cmnService.parseNumberOrZero(res.list.data?.count);
        this.mapListRespponse(res.list.data?.result || []);
        if (res.list.data?.result?.length === 0) {
          this.endOfResults = true;
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.scroolLoader = false;
        this.errMsg = "Failed to fetch response";
      }
    });
  }

  getMoreData() {
    this.scroolLoader = true;
    let params: any = {
      created_date: this.selectedDate,
      page: this.page
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getStockmovementList(params).subscribe({
      next: (res: any) => {
        this.scroolLoader = false;
        this.mapListRespponse(res.data?.result || []);
        if (res.data?.result?.length === 0) {
          this.endOfResults = true;
        }
      },
      error: (err: any) => {
        this.scroolLoader = false;
      }
    });
  }

  mapSaleResponse(data: any) {
    this.stockHighlights.openingStock.value = this.cmnService.parseNumberOrZero(data?.openingStock);
    this.stockHighlights.closingStock.value = this.cmnService.parseNumberOrZero(data?.closingStock);
    this.stockHighlights.stockIn.value = this.cmnService.parseNumberOrZero(data?.stockIn);
    this.stockHighlights.stockOut.value = this.cmnService.parseNumberOrZero(data?.stockOut);
    this.stockHighlights.netChange.value = this.cmnService.parseNumberOrZero(data?.netChange)
  }

  mapListRespponse(data: any) {
    if (!data || data?.length == 0) {
      if (this.page === 0) this.errMsg = "No data found";
      return;
    }
    if (!Array.isArray(data)) return;
    let tableData = data.map((item: any) => {
      return {
        ...item,
        totalInward: this.cmnService.parseNumberOrNull(item.totalInward),
        totalOutward: this.cmnService.parseNumberOrNull(item.totalOutward),
        closingBalance: this.cmnService.parseNumberOrNull(item.closingBalance),
      };
    });
    this.stockmovementList = [...this.stockmovementList, ...tableData];
  }

  viewAllPurchases(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }

  onScroll() {
    if (this.endOfResults || this.scroolLoader || this.loader) return;
    this.page++;
    this.getMoreData();
  }

  onRowClick(item: any) {
    this.modalService.dismissAll();
    if (this.selectedDate) {
      this.dayBookService.setSavedDayBookDate({
        currentDate: this.selectedDate,
        selectedBranchId: this.selectedBranch
      });
    }
    this.ledgersService.selectedSkuFilter = {
      tyreMake: item.tyreMake || '',
      tyreModel: item.tyreModel || '',
      tyreSize: item.tyreSize || '',
      company: item.company || '',
    };
    this.router.navigate(['/sku-ledger']);
  }

}
